<template>
  <div id="app" class="bg-success row align-items-center">
      <b-card class="w-50 m-auto">
          <b-row no-gutters>
              <b-col md="6">
                  <b-card-img src="https://pp.userapi.com/c628322/v628322236/34d65/ii9Npj5Ty2k.jpg" class="rounded"></b-card-img>
              </b-col>
              <b-col md="6">
                  <b-card-body title="Zakhar Lazorin">
                      <b-card-text>
                          Team Lead, Scrum Master and a bit of Web-Developer.
                      </b-card-text>
                  </b-card-body>
              </b-col>
          </b-row>
      </b-card>
  </div>
</template>

<script>

export default {
  name: 'app',
}
</script>

<style scoped>
    #app {
        height:100vh;
    }
</style>
